import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import logoSvg from "../../assets/icons/MemeStock.svg";
import { Box, Grid, SxProps, Theme, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES } from "../../app/routes";
import { theme } from "../../app/theme";
import { FontsFamily } from "../../constants/fonts-enum";

const Header = ({ sx }: { sx?: SxProps<Theme> }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar
      position="static"
      color="primary"
      sx={{
        bgcolor: "#0062FF",
        backgroundColor: "#0062FF",
        backgroundImage: "none",
        // Extend blue into the status-bar / top safe area
        pt: {
          xs: "max(1.5rem, env(safe-area-inset-top, 0px))",
          md: "max(1.75rem, env(safe-area-inset-top, 0px))",
        },
        height: isMobile ? "29.5rem" : "26.5rem",
        ...sx,
      }}
    >
      <Container maxWidth={false} sx={{ mx: 0, px: { xs: 2, md: 3 } }}>
        <Toolbar disableGutters sx={{ pt: { xs: 0.5, md: 0.75 } }}>
          <Grid container alignItems="center" spacing={2}>
            {/* logo */}
            <Grid item xs={5} md="auto">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  pt: { xs: 0.5, md: 0.75 },
                }}
              >
                <Link to={ROUTES.index}>
                  <Typography
                    variant="h6"
                    noWrap
                    component="a"
                    href="/"
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "flex-start", md: "flex-start" },
                      color: "inherit",
                      textDecoration: "none",
                    }}
                  >
                    <img
                      src={logoSvg}
                      alt="MemeStock"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Typography>
                </Link>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#ffffff",
                    textAlign: "left",
                    mt: 0.75,
                    fontWeight: 800,
                    fontFamily: FontsFamily.Sofia_Pro,
                    whiteSpace: "nowrap",
                    overflow: "visible",
                    fontSize: "1.2rem",
                  }}
                >
                  The people's price target
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
